import { FormFieldModel } from './form-field.model';
import { AbstractFormFieldComponent } from '../components/FormField/abstract-form-field.component';
import { Type } from '@angular/core';

export class MultiContentLibraryFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    label: string;
    description: string;
    maxFiles?: number;
    placeholder?: string;
    hideAutomateImageOption?: boolean;
    hidePanel?: boolean;
    subLabel?: string;
    showRemoveButtonAlways?: boolean;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        label: string,
        {
            description,
            maxFiles = 4,
            placeholder,
        }: {
            description?: string;
            maxFiles?: number;
            placeholder?: string;
        } = {},
        hideAutomateImageOption?: boolean,
        hidePanel?: boolean,
        subLabel?: string,
        showRemoveButtonAlways?: boolean
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.label = label;
        this.description = description;
        this.maxFiles = maxFiles;
        this.placeholder = placeholder;
        this.hideAutomateImageOption = hideAutomateImageOption;
        this.hidePanel = hidePanel;
        this.subLabel = subLabel;
        this.showRemoveButtonAlways = showRemoveButtonAlways;
    }
}
